import {
	PATIENT_TASKS_STATE_ACTION_TYPES,
	PatientTasksActions,
	PatientTasksState,
} from '../../../../types/patientTasks'
import {
	SCHEDULE_ACTION_TYPES,
	ScheduleTasksChangeStatusOfTaskAction,
	ScheduleTasksDeleteTaskAction,
} from '../../../../types/schedule'

const initialState: PatientTasksState = {
	tasks: [],
}

export default (
	state = initialState,
	action:
		| PatientTasksActions
		| ScheduleTasksChangeStatusOfTaskAction
		| ScheduleTasksDeleteTaskAction
): PatientTasksState => {
	switch (action.type) {
		case PATIENT_TASKS_STATE_ACTION_TYPES.PATIENT_TASKS_GET: {
			return {
				...state,
				tasks: action.payload,
			}
		}

		case SCHEDULE_ACTION_TYPES.SCHEDULE_TASKS_SET_DONE_STATUS_FOR_TASK: {
			const updatedTasks = state.tasks.map(task => {
				if (task._id === action.payload.id) {
					return {
						...task,
						settings: {
							...task.settings,
							status: action.payload.status,
						},
					}
				}
				return task
			})

			return {
				...state,
				tasks: updatedTasks,
			}
		}

		case SCHEDULE_ACTION_TYPES.SCHEDULE_TASKS_DELETE_TASK: {
			const updatedTasks = state.tasks.filter(task => task._id !== action.payload)

			return {
				...state,
				tasks: updatedTasks,
			}
		}

		default: {
			return state
		}
	}
}
